import { withTranslation } from "react-i18next"
import { Link } from 'react-router-dom' 
import { useEffect } from "react";
import { Divider, Image, Alert } from "antd";
import { useState } from "react";
import { FilePdfOutlined } from "@ant-design/icons";
import styled from "styled-components";

import * as Styled from '../../../Home/styled';

import { get } from "library/endpoints";
import Text from "components/Text";
import moment from "moment";
import Title from "components/Title";
import { connect } from "react-redux";

const StyledLink = styled(Link)`
  font-size: 14px;
  color: #53b297;

  &:hover {
    color: #13a9c6 !important;
  }
`;

const StyledLinkText = styled(Text)`
  color: #53b297;
  &:hover {
    color: #13a9c6 !important;
  }
`;

/**
 * Details
 * @param {*} props 
 * @returns 
 */
const Details = (props) => {
  const basketId = props.match.params.id;

  const [entry, setEntry] = useState(null);
  const [bill, setBill] = useState(null);
  const [orders, setOrders] = useState([]);
  const [orderInfos, setOrderInfos] = useState(null);
  const [matchingVariants, setMatchingVariants] = useState(null)

  useEffect(() => {
    fetchData();
  }, []) // eslint-disable-line

  const fetchData = async () => {
    try {
      const response = await get(`/frontend/basket/${basketId}`);
      setBill(response.data.bill);
      setOrderInfos(response.data.orderInfos);
      setOrders(response.data.orders);
      setMatchingVariants(response.data.matchingVariants);
      setEntry(response.data.entry);
    } catch (error) {
      console.log(error)
    }
  }

  console.log(orders, orderInfos)

  const getPrice = (item) => {
    return item.support.public_price * item.quantity;
  }

  const handleOnDownloadInvoice = async () => {
    try {
      const { data } = await get(`/frontend/invoices/${bill._id}`);
      window.open(data.invoiceURL)
    } catch (err) {
      console.log(err)
    }
  }

  const getStatus = (status) => {
    switch (status) {
      case 'DRAFT':
        return props.t('Front.Orders.Details.Status.Draft', 'Brouillon')
      case 'IN_PROGRESS':
        return props.t('Front.Orders.Details.Status.InProgress', 'En cours de traitement')
      case 'FULFILLED':
        return props.t('Front.Orders.Details.Status.Fulfilled', 'Complété')
      case 'ERROR':
        return props.t('Front.Orders.Details.Status.Error', 'Erreur')
      case 'PENDING':
        return props.t('Front.Orders.Details.Status.Pending', 'En attente')
      case 'CANCELLED':
        return props.t('Front.Orders.Details.Status.Cancelled', 'Annulée')
      default: 
        return null;
    }
  }

  const isMixedOrder = () => {
    let havePicanova = false;
    let haveCustom = false;

    orders.forEach((o) => {
      if (o.provider === 'picanova') {
        havePicanova = true;
      } else {
        haveCustom = true;
      }
    })

    return haveCustom && havePicanova;
  }

  const applyPromoCodeToPrice = (item, price) => {
    if (entry.promocodeData) {
      if (entry.promocodeData.value_type === 'percent') {
        return price * (((100 - (entry.promocodeData.value)) / 100))
      } else {
        return price - (entry.promocodeData.value * item.quantity)
      }
    }

    return price;
  }

  const checkIfCodeIsApplyable = (item) => {
    if (entry.promocodeData) {
      if (matchingVariants.includes(item.support.variant_id)) {
        return true;
      }
    }
    return false;
  }

  const getTotalPrice = () => {
    let count =  entry.initial_amount;

    if (entry.promocodeData) {     
      // Update count with related promo
      entry.products.forEach((p) => {
        if (matchingVariants.includes(p.support.variant_id)) {
          let toReduce = 0;
          if (entry.promocodeData.value_type === 'percent') {
            toReduce = ((p.support.public_price * p.quantity) * (entry.promocodeData.value / 100))
          } else {
            toReduce = (entry.promocodeData.value) * p.quantity
          }
          count -= toReduce;
        }
      })
    }
    return count;
  }

  if (!entry) {
    return null;
  }

  return (
    <>
      <StyledLink to={`/orders`}>{`< Mes commandes`}</StyledLink>

      <div style={{ width: '100%', margin: 'auto', marginTop: 20, backgroundColor: 'white', padding: 10 }}>
        <Title size={18}>Détail de votre commande du {moment(entry.created_at).format('DD/MM/YYYY')}</Title>
        <Divider style={{ margin: 10 }} />

        {
          entry.products.map((item) => (
            <>
              <Styled.BasketItem>
                <Image src={`${process.env.REACT_APP_S3_FILES_URL}${item.mount.output}`} width={30} />

                <div style={{ marginLeft: 10, marginTop: 5 }}>
                  <Text size={14}>{`${item.support.name_fr} x ${item.quantity}`}</Text>
                  {
                    entry.promocodeData && checkIfCodeIsApplyable(item) && (
                      <Text>Code promo appliqué : {entry.promocodeData.code}</Text>
                    )
                  }
                </div>
  
                {
                  !entry.quotation && (
                    <Text size={15} style={{ marginLeft: 'auto', marginTop: 5 }}>
                      {
                        entry.promocodeData && checkIfCodeIsApplyable(item) ? (
                          <>
                            <del style={{ marginRight: 10, display: 'inline-block' }}>{getPrice(item)}€</del>
                            {`${applyPromoCodeToPrice(item, getPrice(item))}€`}
                          </>
                        ) : (
                          <>{getPrice(item)}€</>
                        )
                      }
                    </Text>
                  )
                }
              </Styled.BasketItem>

              {
                item.options.filter((option) => option.selectedOption !== null).map((option) => (
                  <div style={{ display: 'flex', marginBottom: 5 }}>
                    <Text size={13}>{option.selectedOption.name}</Text>
                    {
                      !entry.quotation && (
                        <Text size={13} style={{ marginLeft: 'auto' }}>{option.selectedOption.price > 0 ? `${option.selectedOption.price}€` : 'Offert'}</Text>
                      )
                    }
                  </div>
                ))
              }

              <Divider style={{ margin: 10 }} />
            </>
          ))
        }

        {
          entry.shipping_fees && (
            <div style={{ display: 'flex', marginBottom: 20, marginTop: 20 }}>
              <Text size={14}>Frais de port</Text>
              <Text size={14} style={{ marginLeft: 'auto' }} >{entry.shipping_fees}€</Text>
            </div>
          )
        }

        <Divider style={{ margin: 10 }} />

        <div style={{ display: 'flex', marginBottom: 20, marginTop: 20 }}>
          <Text size={16}>Montant total TTC</Text>
          <Text size={16} style={{ marginLeft: 'auto' }} color="#176b87" >{entry.shipping_fees ? getTotalPrice() + entry.shipping_fees : getTotalPrice()}€</Text>
        </div>
      </div>
      
      {
        isMixedOrder() && (
          <Alert message="Cette commande vous sera expédiée en plusieurs fois" type="info" />
        )
      }

      {
        orderInfos && (
          <div style={{ width: '100%', margin: 'auto', marginTop: 20, backgroundColor: 'white', padding: 10 }}>
            <Text size={16}>Statut de la commande</Text>
            <Divider style={{ margin: 10 }} />
            <div style={{ display: 'flex', }}>
              <Text bold size={13}>Statut : </Text>
              <Text style={{ marginLeft: 5 }} size={13}>{getStatus(orderInfos.status)}</Text>
            </div>
    
            <div style={{ display: 'flex', marginTop: 10 }}>
              <Text bold size={13}>Transporteur : </Text>
              <Text style={{ marginLeft: 5 }} size={13}>{orderInfos.shipping_method.name}</Text>
            </div>
          </div>    
        )
      }

      {
        orders.filter((o) => o.provider === 'picanova' && o.shippingData).map((o) => (
          <div style={{ width: '100%', margin: 'auto', marginTop: 20, backgroundColor: 'white', padding: 10 }}>
              {
                o.shippingData.map((sd) => (
                  <div style={{ display: 'flex', }}>
                    <Text bold size={13}>Numéro de suivi : </Text>
                    <a style={{ marginLeft: 5, fontSize: 13 }} href={sd.tracking_url} target="_blank" rel="noopener noreferrer">{sd.tracking_number}</a>
                  </div>
                ))
              }
          </div>
        ))
      }

      {
        orders.filter((o) => o.provider !== 'picanova').map((o) => (
          <div style={{ width: '100%', margin: 'auto', marginTop: 20, backgroundColor: 'white', padding: 10 }}>
            <Text size={16}>Statut de la commande pour {`${o.payload.support.parentSupport.name_fr}`}</Text>
            <Divider style={{ margin: 10 }} />
            <div style={{ display: 'flex', }}>
              <Text bold size={13}>Statut : </Text>
              <Text style={{ marginLeft: 5 }} size={13}>{o.order_status}</Text>
            </div>
          </div>
        ))
      }

      <div style={{ width: '100%', margin: 'auto', marginTop: 20, backgroundColor: 'white', padding: 10 }}>
        <div style={{ display: 'flex'}} onClick={() => handleOnDownloadInvoice()}>
          <FilePdfOutlined style={{ fontSize: 16, marginRight: 10 }} />
          <StyledLinkText className="link-color" size={14} cursor="pointer">Télécharger la facture</StyledLinkText>
        </div>
      </div>
    </>
  )
}

const stateToProps = state => ({
  ui: state.ui
})

export default connect(stateToProps)(withTranslation()(Details));